module.exports = __webpack_public_path__ + "img/ring_g_c_null_null.a9ac7175.png";